import React, { useContext } from 'react';

import styled, { css, ThemeContext } from 'styled-components';
import useInkAnalytics from '../../../hooks/useInkAnalytics';
import ErrorContext from '../Controller/errorContext';
import { NewTextAreaProps } from '../../NewTextArea/NewTextArea';

import Controller from '../Controller/Controller';

export const TextAreaElement = styled.textarea`
  ${Controller.styles.base};
  ${Controller.styles.textEntry};

  height: auto;
  overflow: auto;

  ${({ theme }) =>
    theme.unresizable &&
    css`
      resize: none;
    `}
`;

function CoreTextArea(props: NewTextAreaProps) {
  const { externalRef, ...otherProps } = props;
  const [ref] = useInkAnalytics(props, { ref: externalRef });
  const themeContext = useContext(ThemeContext);
  const errorContext = useContext(ErrorContext);

  return (
    <Controller
      {...otherProps}
      type="text"
      aria-errormessage={
        errorContext.hasError && errorContext.errorAutoInvalidate ? errorContext.errorMessageId : undefined
      }
      aria-invalid={props.invalid || (errorContext.hasError && errorContext.errorAutoInvalidate)}
      render={controllerProps => {
        const { render, invalid, unresizable, className, theme, ...otherProps } = controllerProps;
        return (
          <Controller.Wrapper className={className} theme={{ ...themeContext, ...controllerProps.theme }}>
            <TextAreaElement
              placeholder=" "
              theme={{
                ...themeContext,
                unresizable,
                ...theme,
              }}
              {...otherProps}
              ref={ref}
            />
          </Controller.Wrapper>
        );
      }}
    />
  );
}

CoreTextArea.displayName = 'CoreTextArea';

CoreTextArea.defaultProps = {
  value: undefined,
  width: 'large',
  rows: 4,
  unresizable: false,
  onChange: undefined,
  invalid: false,
};

export default CoreTextArea;
